import { FaEye, FaInfo, FaStar, FaUtensils } from "react-icons/fa";
import { GoRepo } from "react-icons/go"
import {formatFileSizeDisplay} from "../../Utils";

const RepoItems = ({ repo }) => {
    const {
        name,
        description,
        html_url,
        forks,
        open_issues,
        watchers_count,
        stargazers_count,
        size,
    } = repo;

    return (
        // For Whole Repo
        <a
            href={html_url}
            target="_blank"
            data-aos="zoom-in"
            className="block w-full p-4 bg-gray-900 hover:bg-gray-800 duration-300 
            border border-gray-700 rounded-lg shadow-lg"
        >
            {/* Repo Heading Name */}
            <div className="flex flex-row items-center mb-2">
                <div className="pr-2">
                    <GoRepo size={20} className="text-white" />
                </div>
                <p
                    className="text-xl font-semibold tracking-tight text-white">
                    {name}
                </p>
            </div>
            {/* Repo Description */}
            <p className="font-normal text-white text-base mb-6 line-clamp-2">{description}</p>
            {/* For Repo Stats */}
            <div className="flex flex-row items-center justify-between">
                <div className="flex flex-row">
                    <div className="flex flex-row items-center w-fit bg-blue-900 text-blue-300 
                        text-xs font-medium mr-1 px-2.5 py-0.5 rounded-full">
                        <FaEye className="mr-1" />{watchers_count}
                    </div>
                    <div className="flex flex-row items-center w-fit bg-green-900 text-green-300 
                        text-xs font-medium mr-1 px-2.5 py-0.5 rounded-full">
                        <FaStar className="mr-1" />{stargazers_count}
                    </div>
                    <div className="flex flex-row items-center w-fit bg-red-900 text-red-300 
                        text-xs font-medium mr-1 px-2.5 py-0.5 rounded-full">
                        <FaInfo className="mr-1" />{open_issues}
                    </div>
                    <div className="flex flex-row items-center w-fit bg-yellow-900 text-yellow-300 
                        text-xs font-medium mr-1 px-2.5 py-0.5 rounded-full">
                        <FaUtensils className="mr-1" />{forks}
                    </div>
                </div>
                <div>
                    <p className="text-xs text-white text-semibold">{formatFileSizeDisplay(size)}</p>
                </div>
            </div>
        </a>


    )
}

export default RepoItems;